import React from 'react';
import Icon from '@welldev-group/rcl-icon';
import PropTypes from 'prop-types';
import creditCardIconName from './helpers/CreditCardHelper';

const CreditCardIcon = props => {
  const { cardType } = props;

  return (
    <Icon
      key={cardType}
      size="xl"
      color="tertiary"
      name={creditCardIconName(cardType)}
    />
  );
};

CreditCardIcon.propTypes = {
  cardType: PropTypes.string.isRequired,
};

export default CreditCardIcon;
